import { render } from "./StickyFooter.vue?vue&type=template&id=8b8f3a62"
import script from "./StickyFooter.vue?vue&type=script&lang=js"
export * from "./StickyFooter.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/poll/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/StickyFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b8f3a62"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b8f3a62', __exports__)) {
    console.log('reload')
    api.reload('8b8f3a62', __exports__)
  }
  
  module.hot.accept("./StickyFooter.vue?vue&type=template&id=8b8f3a62", () => {
    console.log('re-render')
    api.rerender('8b8f3a62', render)
  })

}


export default __exports__